import { useState } from "react";
import { useAuth } from "../hooks/useAuth";

const F = "'DM Sans', system-ui, sans-serif";

export default function ChangePassword({ onClose }) {
  const { api } = useAuth();
  const [current, setCurrent] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError("");
    if (!current || !newPw || !confirm) return setError("All fields are required");
    if (newPw.length < 8) return setError("New password must be at least 8 characters");
    if (!/[a-zA-Z]/.test(newPw) || !/[0-9]/.test(newPw)) return setError("Must contain at least one letter and one number");
    if (newPw !== confirm) return setError("New passwords do not match");
    setLoading(true);
    try {
      await api.patch("/auth/password", { currentPassword: current, newPassword: newPw });
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const overlay = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 };
  const modal = { background: "#fff", borderRadius: "12px", padding: "1.5rem", width: "100%", maxWidth: "400px", boxShadow: "0 25px 50px rgba(0,0,0,0.3)" };
  const inp = { width: "100%", padding: "0.625rem 0.75rem", border: "1.5px solid #d1d5db", borderRadius: "8px", fontSize: "0.875rem", fontFamily: F, outline: "none", boxSizing: "border-box", marginTop: "0.25rem" };
  const label = { display: "block", fontSize: "0.8125rem", fontWeight: "500", color: "#374151", marginBottom: "0.75rem", fontFamily: F };

  if (success) {
    return (
      <div style={overlay} onClick={onClose}>
        <div style={modal} onClick={e => e.stopPropagation()}>
          <div style={{ textAlign: "center", padding: "1rem 0" }}>
            <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>✅</div>
            <h3 style={{ fontSize: "1rem", fontWeight: "600", color: "#0f172a", fontFamily: F }}>Password Changed</h3>
            <p style={{ fontSize: "0.8125rem", color: "#64748b", fontFamily: F, marginTop: "0.5rem" }}>Your password has been updated successfully.</p>
            <button onClick={onClose} style={{ marginTop: "1rem", padding: "0.5rem 1.5rem", background: "#0f172a", color: "#fff", border: "none", borderRadius: "8px", fontSize: "0.875rem", fontWeight: "600", cursor: "pointer", fontFamily: F }}>Close</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={e => e.stopPropagation()}>
        <h3 style={{ fontSize: "1.0625rem", fontWeight: "600", color: "#0f172a", marginBottom: "1.25rem", fontFamily: F }}>Change Password</h3>
        {error && <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", padding: "0.625rem", marginBottom: "1rem", fontSize: "0.8125rem", color: "#991b1b", fontFamily: F }}>{error}</div>}
        <label style={label}>Current Password<input type="password" value={current} onChange={e => setCurrent(e.target.value)} style={inp} /></label>
        <label style={label}>New Password<input type="password" value={newPw} onChange={e => setNewPw(e.target.value)} style={inp} /></label>
        <label style={label}>Confirm New Password<input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} style={inp} onKeyDown={e => e.key === "Enter" && handleSubmit()} /></label>
        <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem" }}>
          <button onClick={onClose} style={{ flex: 1, padding: "0.625rem", background: "#f1f5f9", color: "#475569", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "0.875rem", fontWeight: "500", cursor: "pointer", fontFamily: F }}>Cancel</button>
          <button onClick={handleSubmit} disabled={loading} style={{ flex: 1, padding: "0.625rem", background: loading ? "#94a3b8" : "#0f172a", color: "#fff", border: "none", borderRadius: "8px", fontSize: "0.875rem", fontWeight: "600", cursor: loading ? "not-allowed" : "pointer", fontFamily: F }}>{loading ? "Saving..." : "Update Password"}</button>
        </div>
      </div>
    </div>
  );
}
